export default __webpack_public_path__ + "static/media/slide14.9b47ae88.png";